import React from 'react';
import { Router } from 'react-router-dom';
import { createBrowserHistory } from 'history';
import { create } from 'jss';
import rtl from 'jss-rtl';
import MomentUtils from '@date-io/moment';
import { SnackbarProvider } from 'notistack';
import { jssPreset, StylesProvider, ThemeProvider } from '@material-ui/core';
import { MuiPickersUtilsProvider } from '@material-ui/pickers';
import GlobalStyles from 'src/components/elements/GlobalStyles';
import ScrollReset from 'src/components/elements/ScrollReset';
// import SettingsNotification from 'src/components/elements/SettingsNotification';
import { AuthProvider } from 'src/contexts/JWTAuthContext';
import useSettings from 'src/hooks/useSettings';
import { createTheme } from 'src/theme';
import routes, { renderRoutes } from 'src/routes';
import Notifier from './components/elements/Notifier';
import { THEMES } from 'src/helpers/Constants';

const jss = create({ plugins: [...jssPreset().plugins, rtl()] });
const history = createBrowserHistory();

const App = () => {
  const { settings } = useSettings();

  const theme = createTheme({
    direction: settings?.direction   || 'ltr',
    responsiveFontSizes: settings?.responsiveFontSizes || false,
    theme: settings?.theme || THEMES.LIGHT   // 👈 fallback explícito
  });

  return (
    <ThemeProvider theme={theme}>
      <StylesProvider jss={jss}>
        <MuiPickersUtilsProvider utils={MomentUtils}>
          <SnackbarProvider
            maxSnack={3}
            autoHideDuration={3000}
            preventDuplicate
          >
            <Router history={history}>
              <AuthProvider>
                <Notifier />
                <GlobalStyles />
                <ScrollReset />
                {/* <SettingsNotification /> */}
                {renderRoutes(routes)}
              </AuthProvider>
            </Router>
          </SnackbarProvider>
        </MuiPickersUtilsProvider>
      </StylesProvider>
    </ThemeProvider>
  );
};

export default App;
